var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"video-block"},[_c('div',{staticClass:"container"},[_c('BlogComponentWrapper',{attrs:{"component":_vm.additionalComponent}},[_c('div',{staticClass:"col-lg-9 offset-lg-1"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.src,"allowfullscreen":""}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }